<template>
  <router-view
    @snack="toggleSnack"
    @loading="toggleLoading"
    @sessionSync="sessionSync"></router-view>
</template>

<script>

export default {
  name: 'ViewContent',
  methods: {
    toggleSnack (snack) {
      this.$emit('snack', snack)
    },

    toggleLoading (loading) {
      this.$emit('loading', loading)
    },

    sessionSync () {
      this.$emit('sessionSync')
    }
  }
}
</script>
